import { Injectable } from '@angular/core';
import { FormControl, Validators, FormGroup, FormArray } from '@angular/forms';
import { AttributeBase } from '@approot/models';

@Injectable({
  providedIn: 'root'
})
export class AttributeControlService {
  constructor() {}

  toFormGroup(attributes: AttributeBase<any>[]) {
    let group: any = {};
    attributes.forEach(attribute => {
      const updateOn: 'change' | 'blur' | 'submit' =
        attribute.updateOn || 'change';
      if (
        attribute.controlType === 'list' ||
        attribute.controlType === 'bidAskList'
      ) {
        group = {
          ...group,
          ...this.toFormGroup(attribute.attributes).controls
        };
      } else if (
        (attribute.key === 'schedule' ||
          attribute.key === 'exerciseSchedule' ||
          attribute.key === 'floatingLegSchedule' ||
          attribute.key === 'fixedLegSchedule' ||
          attribute.key === 'fixedLegSchedule1' ||
          attribute.key === 'fixedLegSchedule2' ||
          attribute.key === 'optionsPortfolio' ||
          attribute.key === 'optionsPortfolioSpots' ||
          attribute.key === 'basket') &&
        attribute.controlType === 'button'
      ) {
        // these use an array of form controls
        group[attribute.key] = attribute.required
          ? new FormArray(attribute.value || [], {
              validators: [Validators.required, Validators.minLength(1)]
            })
          : new FormArray(attribute.value || []);
      } else if (attribute.controlType === 'dropdown') {
        // default values should be null, else ng-select will recognize data being in the drop down
        // and not do certain things such as display a placeholder
        group[attribute.key] = attribute.required
          ? new FormControl(attribute.value || null, {
              validators: Validators.required,
              updateOn
            })
          : new FormControl(attribute.value || null, { updateOn });
      } else if (attribute.controlType === 'multiSelect') {
        group[attribute.key] = new FormControl(attribute.value || [], {
          validators: [Validators.minLength(attribute.required ? 1 : 0)],
          updateOn
        });
      } else {
        group[attribute.key] = attribute.required
          ? new FormControl(attribute.value || '', {
              validators: Validators.required,
              updateOn
            })
          : new FormControl(attribute.value || '', { updateOn });
      }

      if (attribute.disabled) {
        // if the attribute should be disabled on creation disable it
        group[attribute.key].disable();
      }
    });
    return new FormGroup(group);
  }
}
